// extracted by mini-css-extract-plugin
export var addViewLink = "_1d-1";
export var availabilityIcon = "_1d-16";
export var availabilitySelectionIcon = "_1d-15";
export var backButton = "_1d-2";
export var backIcon = "_1d-z";
export var conversationCount = "_1d-3";
export var dragHandle = "_1d-5";
export var dropdown = "_1d-e";
export var dropdownIcon = "_1d-7";
export var dropdownOption = "_1d-6";
export var dropdownTriangle = "_1d-d";
export var expand = "_1d-f";
export var folder = "_1d-i";
export var folderItem = "_1d-c";
export var icon = "_1d-8";
export var iconRow = "_1d-9";
export var image = "_1d-a";
export var logo = "_1d-b";
export var navContainer = "_1d-h";
export var navigationFooter = "_1d-g";
export var pageShell = "_1d-0";
export var placeholderAvailable = "_1d-11";
export var placeholderBox = "_1d-14";
export var placeholderBusy = "_1d-13";
export var placeholderUnavailable = "_1d-12";
export var profile = "_1d-k";
export var profileContainer = "_1d-m";
export var profileDropdown = "_1d-n";
export var profileImage = "_1d-l";
export var profileMain = "_1d-o";
export var profileSubtitle = "_1d-q";
export var profileTitle = "_1d-p";
export var reorderIcon = "_1d-r";
export var sentLine = "_1d-u";
export var settingsHeader = "_1d-s";
export var sidenavTextColor = "_1d-y";
export var spamLine = "_1d-t";
export var subitemWithTag = "_1d-4";
export var supportItems = "_1d-j";
export var teamText = "_1d-10";
export var viewLine = "_1d-x";
export var viewLineButton = "_1d-w";
export var viewLineButtons = "_1d-v";